import API from '../api';

export default class CourseService {
  constructor() {
    this.API = new API();
  }
  getAllCourses = () => this.API.get('/course/');

  getCourse = (id) => this.API.get(`/course/${id}`);
}
